import React, { useState } from 'react'
import { Alert, Button, Space, Typography, theme } from 'antd'
import { useSelector, useDispatch } from 'react-redux'
import { rubricRefinementSelectors } from '../../../../../../../store/selectors/rubricRefinement.selectors'
import { CheckOutlined, DownOutlined, RightOutlined } from '@ant-design/icons'
import PatternIcon from '../../../../../../../components/common/PatternIcon'
import { setHoveredCategoryId, setHoveredRefinementItemId } from '../../../../../../../store/slices/rubric-refinement.slice'
import MarkdownRenderer from '../../../../../../../components/common/markdown-renderer/MarkdownRenderer'
import { useRefinementFlow } from '../hooks/useRefinementFlow'
import useRubricContext from '../../../../../../../hooks/useRubricContext'
const { Text } = Typography

const CategoryCard = ({ category, refinementItemId, isDisabled }) => {
    const { handleCategorySelect } = useRefinementFlow()
    const refinementItem = useSelector(state => rubricRefinementSelectors.refinementItemById(state, refinementItemId))
    const isSelected = refinementItem?.selectedCategoryId === category.id
    const { getCategoryById } = useRubricContext()
    const categoryDetails = getCategoryById(category.id)
    const { token: themeToken } = theme.useToken()
    const dispatch = useDispatch()
    const [isExpanded, setIsExpanded] = useState(false)

    const handleCategoryChoice = () => {
        if (isDisabled) return
        handleCategorySelect(refinementItemId, category.id)
    }

    const handleMouseEnter = () => {
        dispatch(setHoveredCategoryId(category.id))
        dispatch(setHoveredRefinementItemId(refinementItemId))
    }

    const handleMouseLeave = () => {
        dispatch(setHoveredCategoryId(null))
        dispatch(setHoveredRefinementItemId(null))
    }

    return (
        <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} style={{ height: '100%' }}>
            <Button
                className={`category-choice__option ${isDisabled ? 'disabled' : ''}`}
                type='text'
                onClick={handleCategoryChoice}
                data-test='refinement-category-card'
                data-test-id={category.id}
                style={{
                    backgroundColor: isSelected ? themeToken.colorSuccessBg : themeToken.colorBgContainer,
                    borderColor: isSelected ? themeToken.colorSuccess : null,
                    padding: '16px',
                    height: '100%',
                    width: '100%',
                    position: 'relative',
                }}
            >
                <Space direction='vertical' style={{ width: '100%', height: '100%' }} size='middle' align='start'>
                    <Space align='start'>
                        <Text
                            type='secondary'
                            strong
                            style={{ fontSize: '14px', wordBreak: 'break-word', whiteSpace: 'pre-wrap' }}
                        >
                            {categoryDetails && (
                                <PatternIcon
                                    id={category.id}
                                    colorId={categoryDetails?.colorId}
                                    content={categoryDetails?.grade}
                                    type='pattern'
                                    color={categoryDetails?.color}
                                    suffix='pt'
                                    style={{ marginRight: '8px', fontWeight: 'normal' }}
                                />
                            )}
                            {categoryDetails?.name}
                        </Text>
                        {isSelected && <CheckOutlined style={{ color: themeToken.colorSuccess }} />}
                    </Space>
                    {/* {category.tags?.length > 0 && (
                        <Space wrap>
                            {category.tags.map(tag => (
                                <CategoryCardTag key={tag} tag={tag} />
                            ))}
                        </Space>
                    )} */}

                    <MarkdownRenderer
                        content={category.description}
                        type='secondary'
                        style={{ width: '100%', wordBreak: 'break-word', whiteSpace: 'pre-wrap' }}
                    />
                    <Alert
                        onClick={e => {
                            e.stopPropagation()
                            setIsExpanded(prev => !prev)
                        }}
                        style={{
                            cursor: 'pointer',
                            backgroundColor: 'transparent',
                        }}
                        message={
                            <Text
                                type='secondary'
                                style={{
                                    fontSize: '14px',
                                    wordBreak: 'break-word',
                                    whiteSpace: isExpanded ? 'pre-wrap' : undefined,
                                }}
                            >
                                <Text strong type='secondary' style={{ display: 'flex', alignItems: 'center' }}>
                                    Why Does It {!category.isAdequate ? 'Not ' : ''}Apply?
                                    {isExpanded ? (
                                        <DownOutlined style={{ marginLeft: '4px', fontSize: '12px' }} />
                                    ) : (
                                        <RightOutlined style={{ marginLeft: '4px', fontSize: '12px' }} />
                                    )}
                                </Text>
                                {isExpanded && category.explanation}
                            </Text>
                        }
                        type={category.isAdequate ? 'info' : 'warning'}
                    />
                </Space>
            </Button>
        </div>
    )
}

export default CategoryCard
